import { numRe } from "./presets";

export function parseGroups(blocks) {
  const groups = [];
  let cur = null;
  const flush = () => {
    if (cur) groups.push(cur);
    cur = null;
  };
  blocks.forEach((b) => {
    if (b.h2 !== undefined) {
      flush();
      groups.push({ h2: b.h2 });
    } else if (b.h3 !== undefined) {
      flush();
      cur = { title: b.h3, nodes: [] };
    } else {
      if (!cur) cur = { title: null, nodes: [] };
      if (b.h4 !== undefined) cur.nodes.push({ t: "h4", v: b.h4 });
      else if (b.ul !== undefined) cur.nodes.push({ t: "ul", v: b.ul });
      else cur.nodes.push({ t: "p", v: b.p });
    }
  });
  flush();
  return groups;
}

export function classify(g) {
  const paras = g.nodes.filter((n) => n.t === "p");
  const hasUl = g.nodes.some((n) => n.t === "ul");
  const numbered = paras.filter((n) => numRe.test(n.v));
  if (numbered.length >= 3) return "steps";
  if (hasUl) return "checklist";
  return "offering";
}

export function buildLayout(blocks) {
  const groups = parseGroups(blocks);
  const h2Index = groups.findIndex((g) => g.h2 !== undefined);
  const h2Title = h2Index >= 0 ? groups[h2Index].h2 : null;
  const pre = groups.slice(0, h2Index >= 0 ? h2Index : groups.length).filter((g) => g.h2 === undefined);
  const post = (h2Index >= 0 ? groups.slice(h2Index + 1) : []).filter((g) => g.h2 === undefined);

  const sections = [];
  let buf = [];
  const flushBuf = () => {
    if (buf.length) {
      sections.push({ type: "offerings", groups: buf, heading: sections.length === 0 ? h2Title : null });
      buf = [];
    }
  };
  post.forEach((g, i) => {
    const isLast = i === post.length - 1;
    const kind = classify(g);
    if (isLast && kind === "offering") {
      flushBuf();
      sections.push({ type: "closing", group: g });
      return;
    }
    if (kind === "offering") {
      buf.push(g);
      return;
    }
    flushBuf();
    sections.push({ type: kind, group: g });
  });
  flushBuf();

  return { pre, sections, h2Title };
}

/* Per-service design packs so no two service pages look alike */
export function variantFor(idx) {
  const OFF = ["tabs", "zigzag", "accordion", "grid"];
  const STP = ["timeline", "stepper"];
  const CHK = ["split", "grid"];
  return {
    offerings: OFF[idx % 4],
    steps: STP[idx % 2],
    checklist: CHK[Math.floor(idx / 3) % 2],
  };
}
